import {
    ChangeDetectionStrategy,
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import {
    ActionPreviewToggleSection,
} from '../../../../../services/gable/gable.service';

/**
 * `toggle` section — a single checkbox for an optional side effect
 * (e.g. "Send email to homeowners"). The `key` on the section is the
 * slot under `pendingEdits.toggles[key]` so one section type covers
 * every yes/no choice an action wants to surface.
 */
@Component({
    selector: 'app-ap-toggle-section',
    templateUrl: './toggle-section.component.html',
    styleUrls: ['./toggle-section.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [CommonModule],
})
export class ActionPreviewToggleSectionComponent {
    @Input({ required: true }) section!: ActionPreviewToggleSection;
    @Input() pendingValue: boolean | null = null;
    @Input() disabled = false;

    @Output() readonly edit = new EventEmitter<{ key: string; value: boolean }>();

    get value(): boolean {
        return this.pendingValue ?? this.section.value;
    }

    onChange(checked: boolean): void {
        this.edit.emit({ key: this.section.key, value: checked });
    }
}
